var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M70.572 58.492H49.211L37.917 69.651l-24.419-.078 20.184 21.479 69.874-.045 12.85-9.844V69.965l-20.211.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "2.11px"
    },
    transform: "matrix(1.18655 0 0 1.18309 -12.258 -12.139)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.088 69.668V82.44l-8.294 6.105H58.03a5.19 5.19 0 0 1-5.19-5.19V38.522a6.105 6.105 0 0 1 6.106-6.106h19.705a6.525 6.525 0 0 1 6.527 6.527v12.016a.61.61 0 0 0 .61.609h6.718v-4.314l7.143 7.143-7.101 7.1v-4H85.12a5.96 5.96 0 0 1-5.958-5.958V39.244a.796.796 0 0 0-.795-.796H59.26a1.017 1.017 0 0 0-1.02 1.02v42.75a.84.84 0 0 0 .84.839h3.263V69.616z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpout);
export default __webpack_public_path__ + "static/media/pumpout.6a4368be2ab199fed6b4fc0f93e72f5a.svg";
export { ForwardRef as ReactComponent };